import { generalApiPost } from './apiPost'

const getOnlineHelpContent = generalApiPost('get-online-help')

export default getOnlineHelpContent
